import { fromJS, Map } from 'immutable';

export function request(state, { id }) {
    return state.mergeIn(
        [ 'items', id ],
        Map({
            state: 'IN_PROGRESS'
        })
    );
}

export function error(state, { id, errors }) {
    return state.mergeIn(
        [ 'items', id ],
        Map({
            state: 'ERROR',
            errors: fromJS(errors)
        })
    );
}

export function finish(state, { action, id, userId }) {
    let index = state.get('items').findIndex(x => x.get('id') === id);
    if (action === 'assign') {
        return state.mergeIn(
            [ 'items', index ],
            fromJS({assignee: { id: userId }}).merge({
                state: 'FINISHED'
            })
        );
    }
    if (action === 'close') {
        return state.removeIn(
            [ 'items', index ]
        );
    }
    if (action === 'unassign') {
        return state.removeIn([ 'items', index, 'assignee' ]).
        mergeIn( [ 'items', index ], { state: 'FINISHED' });
    }
}
